module.exports = __webpack_public_path__ + "img/MONTES CLAROS - SETCEMG.43698994.png";